module.exports = __webpack_public_path__ + "img/02_title.f336108d.png";